import { Injectable, inject, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeferredStyleLoaderService {
  readonly #document = inject(DOCUMENT);
  #stylesLoaded = false;

  /**
   * Load non-critical styles after initial render
   */
  loadDeferredStyles(): void {
    if (this.#stylesLoaded) return;

    // Use requestIdleCallback if available, otherwise setTimeout
    const loadStyles = () => {
      this.#createStyleLink('styles-deferred.css');
      this.#stylesLoaded = true;
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadStyles);
    } else {
      setTimeout(loadStyles, 100);
    }
  }

  #createStyleLink(href: string): void {
    const link = this.#document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';

    link.onerror = (event) => {
      console.error(`Failed to load deferred stylesheet "${href}".`, event);
    };

    // Add to head
    this.#document.head.appendChild(link);
  }
}
